// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import './Offerings.scss'

interface OfferingItemProps {
  title: string
  description: string
}

const OfferingItem: React.FC<OfferingItemProps> = ({ title, description }): JSX.Element => {
  return (
    <div className="offering-item p-s5 p-md-s8 gap-s7 align-self-center align-self-sm-stretch">
      <h3 className="h2">{title}</h3>
      <span className="d-none d-sm-block">{description}</span>
    </div>
  )
}

const Offerings: React.FC = (): JSX.Element => {
  const sections = [
    {
      title: 'AI-optimized Compute',
      description:
        'Get access to single nodes or clusters featuring Intel Gaudi AI Processors, Intel Max GPUs and Xeon CPUs.'
    },
    {
      title: 'Developer-ready',
      description: 'Access pre-configured environments and essential AI frameworks for rapid development.'
    },
    {
      title: 'Expert partnership',
      description:
        'Our professional services team offers seamless onboarding, proactive support, and transparent solutions for your AI cloud journey.'
    }
  ]

  return (
    <>
      {/* View */}
      <div className="offerings-container p-s8 p-sm-s10">
        <div className="internal-container gap-s10">
          <div className="offerings-title px-s0 px-sm-s10 gap-s8">
            <span className="h4">
              Intel® Tiber™ AI Cloud offers optimized compute infrastructure, ideal for rapid proof-of-concepts and AI
              model validation. We support the open-source software ecosystem in partnership with universities and
              research institutions.
            </span>
          </div>
          <div
            role="img"
            className="offerrings-img py-s4"
            aria-label="ai generated image of a dark data center aisle with servers onboth sides and bright led lights"
          ></div>
          <div className="offerrings-items-container flex-column-reverse flex-md-row gap-s8">
            {sections.map((section, index) => (
              <OfferingItem title={section.title} description={section.description} key={index} />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Offerings
